<div class="tw-flex tw-justify-between tw-py-5 tw-text-gray-600">
  <form [formGroup]="form" class="tw-flex tw-w-full tw-flex-col tw-gap-5">
    <!-- Honorific -->
    <div class="tw-flex tw-flex-col tw-gap-5 tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <div class="tw-flex tw-flex-wrap tw-gap-5">
        <div class="tw-min-w-20 tw-max-w-32 tw-flex-1">
          <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="honorific">Title</label>
          <ate-text-input-control
            id="honorific"
            class="tw-rounded-lg"
            size="small"
            max-length="24"
            model-key="honorific"
            formControlName="honorific"></ate-text-input-control>
          <span class="tw-text-xs tw-text-slate-600">max 80 chars</span>
        </div>
        <div class="tw-min-w-64 tw-flex-1">
          <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="firstName"
            >First Name&nbsp;<span class="tw-text-red-600" title="Required">*</span></label
          >
          <ate-text-input-control
            id="firstName"
            class="tw-rounded-lg"
            size="small"
            max-length="80"
            model-key="firstName"
            formControlName="firstName"></ate-text-input-control>
          <span class="tw-text-xs tw-text-slate-600">max 80 chars</span>
        </div>
        <div class="tw-min-w-64 tw-flex-1">
          <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="lastName">Last Name</label>
          <ate-text-input-control
            id="lastName"
            class="tw-rounded-lg"
            size="small"
            max-length="80"
            model-key="lastName"
            formControlName="lastName"></ate-text-input-control>
          <span class="tw-text-xs tw-text-slate-600">max 80 chars</span>
        </div>
      </div>
    </div>

    <!-- Last Name -->

    <!-- Email Address -->
    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="email">Email Address</label>
      <ate-text-input-control
        id="email"
        class="tw-rounded-lg"
        size="small"
        max-length="80"
        [state]="form.get('email').getError('email') ? 'error' : 'normal'"
        model-key="email"
        formControlName="email"></ate-text-input-control>
      <span class="tw-text-xs tw-text-slate-600">max 80 chars</span>
      @if (form.get('email').getError('email')) {
        <div class="tw-pt-1 tw-text-red-700">Invalid email.</div>
      }
    </div>

    <!-- Mobile Phone Number -->
    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="mobileNumber">Mobile Phone Number</label>
      <ate-text-input-control
        id="mobileNumber"
        class="tw-rounded-lg"
        size="small"
        max-length="80"
        model-key="mobileNumber"
        formControlName="mobileNumber"></ate-text-input-control>
      <span class="tw-text-xs tw-text-slate-600">max 80 chars</span>
    </div>

    <!-- Landline Phone Number -->
    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="landlineNumber">Landline Phone Number</label>
      <ate-text-input-control
        id="landlineNumber"
        class="tw-rounded-lg"
        size="small"
        max-length="80"
        model-key="landlineNumber"
        formControlName="landlineNumber"></ate-text-input-control>
      <span class="tw-text-xs tw-text-slate-600">max 80 chars</span>
    </div>

    <!-- Company Name -->
    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="companyName">Company Name</label>
      <ate-text-input-control
        id="companyName"
        class="tw-rounded-lg"
        size="small"
        max-length="80"
        model-key="companyName"
        formControlName="companyName"></ate-text-input-control>
      <span class="tw-text-xs tw-text-slate-600">max 80 chars</span>
    </div>

    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="acquisition"><span>Acquisition Method</span></label>
      <p class="tw-mb-[10px] tw-text-[13px] tw-text-black">How did this customer come to you?</p>
      <ate-singleselect
        id="acquisition"
        class="tw-rounded-lg"
        size="small"
        [options]="acquisitionOptions"
        model-key="acquisition"
        formControlName="acquisition"></ate-singleselect>
    </div>

    <!-- Customer Type -->
    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="type"><span>Customer Type</span></label>
      <p class="tw-mb-[10px] tw-text-[13px] tw-text-black">The type of customer e.g. 'private', 'corporate', 'festival'.</p>
      <ate-singleselect
        id="type"
        class="tw-rounded-lg"
        size="small"
        [options]="customerTypeOptions"
        model-key="type"
        formControlName="type"></ate-singleselect>
    </div>

    <!-- Address -->
    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <ate-address-input
        label="Address"
        description="The customer's address."
        model-key="address"
        [value]="addressJson"
        (onValueChanges)="onAddressChange($event)"></ate-address-input>
    </div>

    <!-- Repeat Customer -->
    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="repeat"><span>Repeat Customer</span></label>
      <p class="tw-mb-[10px] tw-text-[13px] tw-text-black">Is this a one-off or repeat customer?</p>
      <ate-singleselect
        id="repeat"
        class="tw-rounded-lg"
        size="small"
        [options]="customerRepeatOptions"
        model-key="repeat"
        formControlName="repeat"></ate-singleselect>
    </div>

    <!-- Marketing Opt-in -->
    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="marketing"><span>Marketing Opt-in</span></label>
      <p class="tw-mb-[10px] tw-text-[13px] tw-text-black">Has this customer opted into marketing communications?</p>
      <ate-singleselect
        id="marketing"
        class="tw-rounded-lg"
        size="small"
        [options]="marketingOptions"
        model-key="marketing"
        formControlName="marketing"></ate-singleselect>
    </div>

    <!-- We only need these fields when editing a customer -->
    @if (this.customerUuid) {
      <div class="tw-flex tw-flex-wrap tw-gap-5 tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
        <!-- Customer Status -->

        <div class="tw-min-w-48 tw-flex-1">
          <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="status"><span>Customer Status</span></label>
          <p class="tw-mb-[10px] tw-text-[13px] tw-text-black">Status of the customer through the pipeline e.g. 'lead', 'active'</p>
          <ate-singleselect
            id="status"
            class="tw-rounded-lg"
            size="small"
            [options]="customerStatusOptions"
            model-key="status"
            formControlName="status"></ate-singleselect>
        </div>
        <!-- Archive Status -->
        <div class="tw-min-w-48 tw-flex-1">
          <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="isArchived"><span>Archive Status</span></label>
          <p class="tw-mb-[10px] tw-text-[13px] tw-text-black">Choose the archive status of the customer e.g. 'active', 'archived'</p>
          <ate-singleselect
            id="isArchived"
            class="tw-rounded-lg"
            size="small"
            [options]="isArchivedOptions"
            model-key="isArchived"
            formControlName="isArchived"></ate-singleselect>
        </div>
      </div>
    }

    <div class="tw-border-0 tw-border-b tw-border-solid tw-border-slate-200 tw-px-[20px] tw-pb-5 md:tw-px-[40px]">
      <label class="tw-mb-[10px] tw-block tw-font-bold tw-text-gray-800" for="notes">Notes</label>
      <ate-textarea-control
        class="tw-rounded-lg tw-shadow-[inset_0_0_0_1px_#94A3B8]"
        auto-resize
        max-length="1000"
        use-rich-text
        size="xxsmall"
        id="notes"
        model-key="notes"
        formControlName="notes"></ate-textarea-control>
      <span class="tw-text-xs tw-text-slate-600">max 1000 chars</span>
    </div>
  </form>
</div>

<div class="tw-flex tw-justify-between tw-px-5 tw-pb-5 tw-text-gray-600 md:tw-px-10">
  <ate-button-control class="tw-w-fit" (click)="emitCancelEvent()" color="secondary">Cancel</ate-button-control>
  <ate-button-control [state]="form.valid && !isLoading ? 'normal' : 'disabled'" class="tw-max-w-[150px]" (click)="emitFormSubmit()" color="cta">
    @if (isLoading) {
      <ate-icon class="tw-size-8 tw-animate-spin tw-text-brand-contrast" name="loading-spinner-v3"></ate-icon>
    } @else {
      Save Customer
    }
  </ate-button-control>
</div>
